import { RoleGate, UserRole } from "@/features/auth";
import { Icon } from "@/shared/components";
import { cn } from "@/shared/utils";

type BetrokkenStationChipProps = {
    label: string;
    stationCode: string;
    onRemove?: () => void;
    disabled?: boolean;
    className?: string;
};

export function BetrokkenStationChip({ label, stationCode, onRemove, disabled = false, className }: Readonly<BetrokkenStationChipProps>) {
    return (
        <span
            className={cn(
                "text-s text-content-default leading-l rounded-m border-default flex items-center gap-2 border px-3 py-[5.5px] font-medium text-nowrap",
                className
            )}
            data-testid={`betrokken-station-chip-${stationCode}`}
        >
            {label}
            <RoleGate roles={[UserRole.REGIEVOERDER]}>
                {onRemove && (
                    <button
                        type="button"
                        onClick={onRemove}
                        disabled={disabled}
                        aria-label={`${label} verwijderen`}
                        className="text-content-subtle hover:text-content-default hover:bg-hover outline-focus flex items-center justify-center rounded-s transition-colors focus-visible:outline-2 focus-visible:outline-offset-1 disabled:cursor-not-allowed disabled:opacity-50"
                        data-testid={`betrokken-station-chip-remove-${stationCode}`}
                    >
                        <Icon name="close" size="xs" strokeWidth="thick" />
                    </button>
                )}
            </RoleGate>
        </span>
    );
}
